<template>
    <div class="navLeft powerMenu" style="margin-left:1px">
        <el-menu v-for="(site,index) in navList" :key="site.id" :default-active="$route.path">
            <el-submenu class="el-menu-vertical-demo" :index="index.toString()">
                <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>{{site.name}}</span>
                </template>
                <el-menu-item v-for="(item,index) in site.children" :key="index" :index="item.path" class="userCenterNav" >
                    <div @click="toView(item.path)" :class="'menu'+index" class="menu"><i class="el-icon-caret-right mr15"></i>{{item.name}}</div>
                </el-menu-item>
            </el-submenu>
            
            <!-- <label v-for="(item,index) in site.children" :key="index">
                <el-menu class="el-menu-vertical-demo" v-if="item.children">
                    <el-submenu :index="String(index)" v-if="item.children">
                        <template slot="title">
                           <i class="el-icon-location"></i>
                           <router-link :to="{path:item.path}"><span>{{item.name}}</span></router-link>
                        </template>
                        <label v-for="(itemSub,i) in item.children" :key="i">
                            <el-menu-item-group v-if="itemSub.children">
                                <el-submenu>
                                    <label v-for="(itemSubSub,m) in itemSub.children" :key="m">
                                        <el-menu-item>{{itemSubSub.name}}</el-menu-item>
                                    </label>
                                </el-submenu>
                            </el-menu-item-group>
                            <router-link  v-else :to="{path:itemSub.path}"><el-menu-item >{{ itemSub.name }}</el-menu-item></router-link>
                        </label>
                    </el-submenu>
                </el-menu>
                <el-menu v-else>
                    <router-link :to="{path:item.path}"><el-menu-item> {{item.name}} </el-menu-item></router-link>
                </el-menu>
            </label> -->
        </el-menu>
    </div>
</template>

<script>

  export default {
    data() {
        return {
            navList: this.$store.getters.viewrouter
        }
    },
    methods: {
        toView(path){
            this.$router.push(path)
        }
    }
  }
</script>

<style lang="scss">
   .userCenter{
       .navLeft{
           margin-top: 20px;
           border: 1px solid #e3e2e1;
           border-left: 1px solid #e3e2e1;
           .el-menu{
               border: 0;
               text-align: center;
            }
       }
}
   .powerMenu{
       .el-submenu{
           .el-submenu__title{
                border-bottom: 1px solid #e3e2e1;
           }
           .el-menu{
             border-bottom: 1px solid #e3e2e1;
           }
           .userCenterNav{
               text-align: left;
               padding-left: 60px!important;
           }
       }
       
       
   }
</style>>
    